<div mulo-page-line class="authors" [class.as-details]="authorsDetails" *ngIf="creators && creators.length > 0">
    <ng-container *ngIf="!authorsDetails">
        <ng-container
            *ngFor="
                let author of creators | slice: 0 : maxVisibleAuthors;
                let first = first;
                let last = last;
                let i = index
            "
        >
            <ng-container *ngIf="creators.length > 1">
                <span *ngIf="(!last || creators.length > maxVisibleAuthors) && !first">, </span>
                <span *ngIf="last && creators.length <= maxVisibleAuthors">
                    {{ 'research.portal.fulldisplay.creators.and' | translate }}
                </span>
            </ng-container>
            <ng-container *ngTemplateOutlet="authorDisplay; context: { author: author }"></ng-container>
        </ng-container>
        <span *ngIf="creators.length > maxVisibleAuthors">, &hellip;</span>
    </ng-container>

    <div class="details" *ngIf="authorsDetails">
        <div *ngFor="let author of creators; index as i" class="margin-bottom-xs">
            <p>
                <ng-container *ngTemplateOutlet="authorDisplay; context: { author: author }"></ng-container>
                <span class="italic" *ngIf="creatorsConfig().displayRoles && author.role">
                    ({{ author.role | translate }})</span
                >
            </p>
            @if (creatorsConfig().displayAutorAffilations) {
                @if (author.affiliationNameList?.length > 0) {
                    @for (affiliationName of author.affiliationNameList; track $index) {
                        <p>{{ affiliationName }}</p>
                    }
                } @else {
                    <p>{{ author.affiliationName }}</p>
                }
            }
        </div>
    </div>

    <ng-container *ngIf="showUserDetails() || creators.length > maxVisibleAuthors">
        <button
            *ngIf="!authorsDetails"
            mat-button
            color="primary"
            (click)="toggleAuthorsDetails()"
            class="details-toggle is-inline"
            hideOnPrint
        >
            <ng-container *ngIf="creators.length === 1">
                {{ 'research.portal.fulldisplay.authors.showDetails' | translate }}
            </ng-container>
            <ng-container *ngIf="creators.length > 1">
                {{ 'research.portal.fulldisplay.authors.showDetailsMultiple' | translate: { val0: creators.length } }}
            </ng-container>
        </button>
        <button
            *ngIf="authorsDetails"
            mat-raised-button
            color="primary"
            (click)="toggleAuthorsDetails()"
            class="details-toggle has-icon"
            hideOnPrint
        >
            <mat-icon svgIcon="chevron-up"></mat-icon>
            {{ 'research.portal.fulldisplay.authors.hideDetails' | translate }}
        </button>
    </ng-container>
</div>

<ng-template #authorDisplay let-author="author">
    <ng-container *ngIf="isProfileActivate; else profileIsNotActive">
        <a
            *ngIf="author.urlIdentifier; else noProfile"
            [routerLink]="['/profile/' + author.urlIdentifier]"
            [queryParams]="{ institution: institutionCode }"
            style="color: currentColor"
            >{{ author.displayName }}</a
        >
        <ng-template #noProfile>
            <ng-container *ngTemplateOutlet="display; context: { author: author }"></ng-container>
        </ng-template>
    </ng-container>
    <ng-template #profileIsNotActive>
        <ng-container *ngIf="!author.isAffiliated; else isAffiliated">
            <ng-container *ngTemplateOutlet="display; context: { author: author }"></ng-container>
        </ng-container>
        <ng-template #isAffiliated>
            <a
                *ngIf="portalNewSearchResults; else primoSearch"
                routerLink="/search/outputs"
                [queryParams]="getCreatorSearchQueryParams(author)"
                style="color: currentColor"
                >{{ author.displayName }}</a
            >
            <ng-template #primoSearch>
                <a [href]="getAuthorSearchLinkInDiscovery(author)" target="_blank" style="color: currentColor">{{
                    author.displayName
                }}</a>
            </ng-template>
        </ng-template>
    </ng-template>
</ng-template>
<ng-template #display let-author="author">
    <span class="author-name" style="color: currentColor">{{ author.displayName }}</span>
</ng-template>
